<script setup>
import Icon from 'next/icon/Icon.vue';
</script>

<template>
  <div class="relative inline-flex items-center justify-center">
    <div class="absolute inset-0 rounded-full ai-glow" aria-hidden="true" />
    <Icon v-once icon="i-woot-captain" class="relative z-10" />
  </div>
</template>
